import { api } from '@/api'
import { apiUrl } from '@/env';
import axios from 'axios';
import { getTokenHeaders } from '@/api/api-utils'
import { PROVIDER_ID, PROVIDER_TITLE_FOR_ENDPOINTS, PROVIDER_LIST } from "@/utils";

const USER_ID = 'current_user_id';
const USER = 'client';
const ADVISOR = 'advisor';

const requestOptions = {
  withCredentials: true
}

export const fundApi = {

  async getAccountPlaidInfo(accountId) {
    return await api.getPlaidAchCheck(accountId);
  },
  async advisorInitiatePullAchDeposit(data) {
    const userId = sessionStorage.getItem(USER_ID);
    requestOptions['headers'] = getTokenHeaders();
    return axios.post(`${apiUrl}/api/v1/funding/advisor/${userId}/account/${data.account_id}/provider/${data.provider_id}/pull/ach-deposit`, data, requestOptions);
  },
  async clientInitiatePullAchDeposit(data) {
    const userId = sessionStorage.getItem(USER_ID);
    requestOptions['headers'] = getTokenHeaders();
    return axios.post(`${apiUrl}/api/v1/funding/client/${userId}/account/${data.account_id}/provider/${data.provider_id}/pull/ach-deposit`, data, requestOptions);
  },
  async getPrimetrustRolloverFundTransferInstruction(account_id) {
    requestOptions['headers'] = getTokenHeaders();
    const userId = sessionStorage.getItem(USER_ID);
    return  axios.get(`${apiUrl}/api/v1/funding/user/${userId}/account/${account_id}/primetrust/rollover-instructions`, requestOptions)
  },
  async createPrimetrustRolloverTransferInstruction(account_id) {
    requestOptions['headers'] = getTokenHeaders();
    const userId = sessionStorage.getItem(USER_ID);
    const data = null;
    return axios.post(`${apiUrl}/api/v1/funding/user/${userId}/account/${account_id}/primetrust/rollover-instructions`, data ,requestOptions)
  },
  async getPrimetrustWireInfo(payload) {
    const userId = sessionStorage.getItem(USER_ID);
    requestOptions['headers'] = getTokenHeaders();
    let provider = ""
    provider = payload.provider_id === PROVIDER_ID.PRIMETRUST ? PROVIDER_TITLE_FOR_ENDPOINTS.PRIMETRUST : PROVIDER_TITLE_FOR_ENDPOINTS.COINBASEPRIME
    return axios.get(`${apiUrl}/api/v1/funding/user/${userId}/account/${payload.account_id}/${provider}/get-push-info`, requestOptions)

  },
  async getAssets(account_id) {
    const response = await api.actDetail(account_id)
    return response.data
  },
  async saveTransferAssets(payload) {
    const userId      = sessionStorage.getItem(USER_ID);
    const account_id  = payload.account_id;
    return axios.post(`${apiUrl}/api/v1/funding/advisor/${userId}/account/${payload.account_id}/create-transfer`, payload, requestOptions)
  },
  async getWireInfo(account_id, provider_id) {
    const userId = sessionStorage.getItem(USER_ID);
    requestOptions['headers'] = getTokenHeaders();
    let provider = ""
    provider = PROVIDER_LIST.find(item => item.id === provider_id).text;
    return axios.get(`${apiUrl}/api/v1/funding/user/${userId}/account/${account_id}/${provider}/get-wire-info`, requestOptions)
  },
  async getIraRolloverInfo(account_id) {
    const userId = sessionStorage.getItem(USER_ID);
    requestOptions['headers'] = getTokenHeaders();
    return axios.get(`${apiUrl}/api/v1/ira-rollover/user/${userId}/account/${account_id}/info`, requestOptions)
  },
  async sendRolloverInstruction(account_id) {
    const userId = sessionStorage.getItem(USER_ID);
    requestOptions['headers'] = getTokenHeaders();
    return axios.post(`${apiUrl}/api/v1/ira-rollover/user/${userId}/account/${account_id}/email-instructions`, {}, requestOptions)
  },  
  async downloadIraRolloverInstructions(account_id) {
    const userId = sessionStorage.getItem(USER_ID);
    return axios.get(`${apiUrl}/api/v1/ira-rollover/user/${userId}/account/${account_id}/download-instructions`, 
      {
        ...requestOptions, 
        headers: getTokenHeaders(),
        responseType: 'blob'
      })
  },
  async getTradingAccounts() {
    const userId = sessionStorage.getItem(USER_ID);
    requestOptions['headers'] = getTokenHeaders();
    return axios.get(`${apiUrl}/api/v1/accounts/advisor/${userId}/funding/accounts/deposit`, requestOptions)
  },
  async sendGeminiInstruction(account_id) {
    const userId = sessionStorage.getItem(USER_ID);
    requestOptions['headers'] = getTokenHeaders();
    return axios.get(`${apiUrl}/api/v1/funding/advisor/${userId}/account/${account_id}/gemini/deliver-wire-info`, requestOptions)
  },
  async sendPrimetrustInstruction(account_id) {
    const userId = sessionStorage.getItem(USER_ID);
    requestOptions['headers'] = getTokenHeaders();
    return axios.get(`${apiUrl}/api/v1/funding/advisor/${userId}/account/${account_id}/primetrust/deliver-push-info`, requestOptions)
  },
  async createGeminiNewAddress(data) {
    const userId = sessionStorage.getItem(USER_ID);
    requestOptions['headers'] = getTokenHeaders();
    return axios.post(`${apiUrl}/api/v1/trade/gemini/user/${userId}/account/${data.account_id}/create-new-address`, data, requestOptions);
  },
  // DEPRECATED OR DEAD CODE
  async createPrimeTrustNewAddress(data, isAdvisor) {
    const userId = sessionStorage.getItem(USER_ID);
    requestOptions['headers'] = getTokenHeaders();
    return axios.post(`${apiUrl}/api/v1/trade/prime-trust/client/${userId}/account/${data.account_id}/create-new-address`, data, requestOptions);
  },
  async createCoinbasePrimeNewAddress(data) {
    const userId = sessionStorage.getItem(USER_ID);
    requestOptions['headers'] = getTokenHeaders();
    return axios.post(`${apiUrl}/api/v1/trade/coinbase-prime/user/${userId}/account/${data.account_id}/create-new-address`, data, requestOptions);
  }, 
  async createAnchorageWalletAddress(data) {
    const userId = sessionStorage.getItem(USER_ID);
    requestOptions['headers'] = getTokenHeaders();
    return axios.post(`${apiUrl}/api/v1/trade/anchorage/user/${userId}/account/${data.account_id}/create-new-address`, data, requestOptions);
  },
  async getDepositAttributions(accountId) {
    const userId = sessionStorage.getItem(USER_ID);
    requestOptions['headers'] = getTokenHeaders();
    return axios.get(`${apiUrl}/api/v1/funding/user/${userId}/account/${accountId}/get-deposit-attributions`, requestOptions);
  },
  async getDepositAttributionsForAdvisor(accountIds) {
    const userId = sessionStorage.getItem(USER_ID);
    requestOptions['headers'] = getTokenHeaders();
    return axios.post(`${apiUrl}/api/v1/funding/advisor/${userId}/accounts/deposit-attributions/get`, {account_ids: accountIds}, requestOptions);
  },
  async updateDepositAttribution(data, accountId) {
    const userId = sessionStorage.getItem(USER_ID);
    requestOptions['headers'] = getTokenHeaders();
    return axios.put(`${apiUrl}/api/v1/funding/user/${userId}/account/${accountId}/update-deposit-attribution`, data, requestOptions);
  },
  async getWalletAddresses(accountId) {
    const userId = sessionStorage.getItem(USER_ID);
    const config = requestOptions;
    config['headers'] = getTokenHeaders();
    return axios.get(`${apiUrl}/api/v1/trade/gemini/user/${userId}/account/${accountId}/wallet-addresses`, config);
  },
  async cryptoAddressInstructions(payload) {
    const userId = sessionStorage.getItem(USER_ID);
    requestOptions['headers'] = getTokenHeaders();
    return axios.post(`${apiUrl}/api/v1/crypto/advisor/${userId}/account/${payload.account_id}/crypto-address-instructions`, payload, requestOptions);
  },
  async getWithdrawableBalance(accountId) {
    const response = await api.actDetail(accountId)
    return response.data.withdrawable_balance
  },
  async clientInitiatePullAchWithdrawal(data) {
    const userId = sessionStorage.getItem(USER_ID);
    requestOptions['headers'] = getTokenHeaders();
    return axios.post(`${apiUrl}/api/v1/funding/user/${userId}/account/${data.account_id}/provider/${data.provider_id}/ach-withdrawal`, data, requestOptions);
  },
async clientInitiateWireWithdrawal(data) {
    const userId = sessionStorage.getItem(USER_ID);
    requestOptions['headers'] = getTokenHeaders();
    return axios.post(`${apiUrl}/api/v1/funding/user/${userId}/account/${data.account_id}/provider/${data.provider_id}/wire-withdrawal`, data, requestOptions);
  },
  async getPrimetrustCustodianAndTrusteeDict() {
    requestOptions['headers'] = getTokenHeaders();
    const userId = sessionStorage.getItem(USER_ID);
    const res = await axios.get(`${apiUrl}/api/v1/funding/client/${userId}/prime-trust-trustee-list`, requestOptions);
    const custodianArray = res.data.data
    const addressDictionary = {}
    custodianArray.forEach( custodian => { 
          addressDictionary[custodian.attributes.name] = {id: custodian.id, address: this.custodianAddressMapper(custodian)}
    }); 
    return addressDictionary; 
  },
  async postPrimetrustTransferInDeposit(data, accountId) {
    requestOptions['headers'] = getTokenHeaders();
    requestOptions['headers']['Content-Type'] = "multipart/form-data"
    
    const userId = sessionStorage.getItem(USER_ID);
    return axios.post(`${apiUrl}/api/v1/funding/user/${userId}/account/${accountId}/transfer-in-deposit`, data, requestOptions);
  },
  async postPrimetrustDistribution(data, accountId) {
    requestOptions['headers'] = getTokenHeaders();
    const userId = sessionStorage.getItem(USER_ID);
    //This endpoint is not yet defined. 
    return axios.post(`${apiUrl}/api/v1/funding/user/${userId}/account/${accountId}/distribution-request`, data, requestOptions);
  },
  async getOriginatorNames(accountId) {
    const userId = sessionStorage.getItem(USER_ID);
    requestOptions['headers'] = getTokenHeaders();
    return axios.get(`${apiUrl}/api/v1/accounts/user/${userId}/account/${accountId}/originator-name`, requestOptions);
  },
  async getColdStorageSettings(accountId) {
    const userId = sessionStorage.getItem(USER_ID);
    requestOptions['headers'] = getTokenHeaders();
    return axios.get(`${apiUrl}/api/v1/funding/user/${userId}/account/${accountId}/cold-storage-settings`, requestOptions);
  },
  async updateColdStorageSettings(data) {
    const userId = sessionStorage.getItem(USER_ID);
    requestOptions['headers'] = getTokenHeaders();
    return axios.put(`${apiUrl}/api/v1/funding/user/${userId}/account/${data.account_id}/cold-storage-settings`, data, requestOptions);
  },
  custodianAddressMapper(custodian) {
    if (custodian.attributes.address.addressLine2) {
      return custodian.attributes.address.addressLine1 + ", " +  custodian.attributes.address.addressLine2 + ", " + custodian.attributes.address.city + ", " + custodian.attributes.address.state +", " +  custodian.attributes.address.zipCode 
    }else {
      return custodian.attributes.address.addressLine1 + ", " + custodian.attributes.address.city + ", " + custodian.attributes.address.state +", " +  custodian.attributes.address.zipCode 
    }
  },
}


